import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b40f7c1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2b40f7c1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40f7c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b40f7c1')) {
      api.createRecord('2b40f7c1', component.options)
    } else {
      api.reload('2b40f7c1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b40f7c1&scoped=true", function () {
      api.rerender('2b40f7c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/Forms/Menu/index.vue"
export default component.exports